/**
 * Labstep
 *
 * @module core/AutoSave/Spinner
 * @desc Autosave spinner feature
 */

import { Loader } from 'labstep-web/core/Loader';
import type React from 'react';
import { getStatusMessage } from '../utils';
import type { IAutoSaveSpinnerProps } from './types';

export const AutoSaveSpinner: React.FC<IAutoSaveSpinnerProps> = ({
  status,
}) =>
  status &&
  (status.isFetching ? (
    <Loader size="tiny" inline active />
  ) : (
    <span style={{ marginRight: '5px' }}>
      {getStatusMessage(status)}
    </span>
  ));
